import { IPagination } from 'app/types/common';

export interface ITeam {
  id: string;
  type: string;
  name: string;
  seasonName: string;
  sport: string;
  userId: string;
  organisationId?: any;
  inviteToken: string;
  createdAt: Date;
  updatedAt: Date;
  status?: any;
  financialStatus: string;
  pendingTeamPaymentCollectionsTotalCount: number;
  paidTeamPaymentCollectionsTotalCount: number;
  overdueTeamPaymentCollectionsTotalCount: number;
  pendingTeamPaymentCollectionsTotalAmount: number;
  paidTeamPaymentCollectionsTotalAmount: number;
  overdueTeamPaymentCollectionsTotalAmount: number;
  numberOfTeamMembers: number;
  connectedToAssociation: boolean;
  teamConnections: any[];
  payments: any[];
  group: any;
  organisation: any;
}

export interface ITeamsState {
  readonly teamsById?: any;
  readonly teamIds?: string[];
  readonly groupIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationTeamIds?: string[];
  readonly currentTeamId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ITeamsSelector extends ITeamsState {
  readonly currentTeam?: any;
  readonly currentFormTeam?: any;
  readonly getTeamsFilteredByTagInSelectFormat?: any;
  readonly teamsByIdInSelectFormat?: any;
}

export enum TeamsActionTypes {
  GET_ALL_TEAMS_REQUESTED = 'redux-app/teams/GET_ALL_TEAMS_REQUESTED',
  GET_ALL_TEAMS_PENDING = 'redux-app/teams/GET_ALL_TEAMS_PENDING',
  GET_ALL_TEAMS_SUCCESS = 'redux-app/teams/GET_ALL_TEAMS_SUCCESS',
  GET_ALL_TEAMS_FAIL = 'redux-app/teams/GET_ALL_TEAMS_FAIL',
  GET_TEAM_REQUESTED = 'redux-app/teams/GET_TEAM_REQUESTED',
  GET_TEAM_PENDING = 'redux-app/teams/GET_TEAM_PENDING',
  GET_TEAM_SUCCESS = 'redux-app/teams/GET_TEAM_SUCCESS',
  GET_TEAM_FAIL = 'redux-app/teams/GET_TEAM_FAIL',
  UPDATE_TEAM_REQUESTED = 'redux-app/teams/UPDATE_TEAM_REQUESTED',
  UPDATE_TEAM_PENDING = 'redux-app/teams/UPDATE_TEAM_PENDING',
  UPDATE_TEAM_SUCCESS = 'redux-app/teams/UPDATE_TEAM_SUCCESS',
  UPDATE_TEAM_FAIL = 'redux-app/teams/UPDATE_TEAM_FAIL',
  CREATE_TEAM_REQUESTED = 'redux-app/teams/CREATE_TEAM_REQUESTED',
  CREATE_TEAM_PENDING = 'redux-app/teams/CREATE_TEAM_PENDING',
  CREATE_TEAM_SUCCESS = 'redux-app/teams/CREATE_TEAM_SUCCESS',
  CREATE_TEAM_FAIL = 'redux-app/teams/CREATE_TEAM_FAIL',
  DELETE_TEAM_REQUESTED = 'redux-app/teams/DELETE_TEAM_REQUESTED',
  DELETE_TEAM_PENDING = 'redux-app/teams/DELETE_TEAM_PENDING',
  DELETE_TEAM_SUCCESS = 'redux-app/teams/DELETE_TEAM_SUCCESS',
  DELETE_TEAM_FAIL = 'redux-app/teams/DELETE_TEAM_FAIL',
  SELECT_TEAM_REQUESTED = 'redux-app/teams/SELECT_TEAM_REQUESTED',
  SELECT_LAST_TEAM_REQUESTED = 'redux-app/teams/SELECT_LAST_TEAM_REQUESTED',
  SELECT_LAST_TEAM_PENDING = 'redux-app/teams/SELECT_LAST_TEAM_PENDING',
  SELECT_LAST_TEAM_FINISHED = 'redux-app/teams/SELECT_LAST_TEAM_FINISHED'
}

export default null;
